// extracted by css-extract-rspack-plugin
export default {"names":"names-XuO6fg"};